// Event timestamps without an offset are returned by the API in UTC.
export const parseEventDate = value => {
    if (!value || typeof value !== 'string') return null;
    const normalized = value.trim();
    if (!normalized) return null;
    const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized) ? normalized : `${normalized}Z`);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const getNextEvent = (events, now = Date.now()) => events.reduce((next, event) => {
    const date = parseEventDate(event.starts_at);
    if (!date || date.getTime() < now) return next;
    return !next || date < parseEventDate(next.starts_at) ? event : next;
}, null);
